import * as React from 'react';
import styled, { keyframes } from 'styled-components';
// styles

const loop = keyframes`
  0% {
    left: 0%;
    opacity: 0;
  }

  10% {
    left: 0%;
    opacity: 1;
  }

  30% {
    left: 0%;
    opacity: 1;
  }

  50% {
    left: 0%;
    opacity: 0;
  }

  70% {
    opacity: 0;
    left: 100%;
  }

  99.99% {
    opacity: 0;
    left: 100%;
  }

  100% {
    opacity: 0;
    left: 0%;
  }
  `;

const SlideShow = styled.ul`
  position: relative;
  width: 896px;
  height: 389px;
  float: left;
  overflow: hidden;
  padding: 0 !important;
`;
const SlideFrame = styled.li`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 0 !important;
  &:nth-child(1) {
    background: url('/images/album/1.jpg');
    background-size: cover;
    animation: ${loop} 30s 0s infinite;
  }
  &:nth-child(2) {
    background: url('/images/album/2.jpg');
    opacity: 0;
    background-size: cover;
    animation: ${loop} 30s 10s infinite;
  }
  &:nth-child(3) {
    background: url('/images/album/3.jpg');
    opacity: 0;
    backgroundsize: cover;
    animation: ${loop} 30s 20s infinite;
  }
`;

// markup
const Slides = () => {
  return (
    <SlideShow>
      <SlideFrame></SlideFrame>
      <SlideFrame></SlideFrame>
      <SlideFrame></SlideFrame>
    </SlideShow>
  );
};

export default Slides;
